<template>
  <div class="zyc-nav-class">
    <div class="zyc-nav-class-t-l"></div>
    <div class="zyc-nav-class-t-r"></div>
    <div class="zyc-nav-class-t-t-l"></div>
    <div class="zyc-nav-class-t-t-r"></div>
    <div class="zyc-nav-class-t-t-title">
      <h3>{{ title }}</h3>
    </div>
    <div class="zyc-nav-class-bg"></div>
    <div class="zyc-nav-class-content" :style="{'max-height':maxHeight+'px','min-height':maxHeight+'px'}">
      <slot></slot>
    </div>
  </div>
  
</template>
<script>
  /**
  * 分类导航容器
  */
  export default {
    name: 'zycNavClass',
    props: {
      title: {
        type: String,
        default: ''
      },
      maxHeight: {
        type: Number,
        default: 0
      }
    },
    model: {
    },
    watch: {
    },
    data() {
      return {
      }
    },
    mounted() {
      
    },
    created() {
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/zyc/container/navClassContainer.vue